import { ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge, type BadgeVariant } from '@/components/ui/badge';
import type { ProductionDeclarationMaterialStatusCode } from '@/types/core/purchase-order/production-declaration-material-status-code';

const MATERIAL_STATUS_BADGE_VARIANT_BY_STATUS: Record<
  ProductionDeclarationMaterialStatusCode,
  BadgeVariant
> = {
  pending: 'blue',
  approved: 'green',
  rejected: 'red',
};

type ProductionDeclarationMaterialStatusAudience = 'supplier' | 'internal';

type ProductionDeclarationMaterialStatusBadgeProps = {
  code: ProductionDeclarationMaterialStatusCode;
  audience: ProductionDeclarationMaterialStatusAudience;
  chevron?: boolean;
};

export function ProductionDeclarationMaterialStatusBadge({
  code,
  audience,
  chevron = false,
}: ProductionDeclarationMaterialStatusBadgeProps) {
  const { t } = useTranslation('productionDeclaration');

  return (
    <Badge
      className='gap-1.5 rounded-full px-4 py-1'
      variant={MATERIAL_STATUS_BADGE_VARIANT_BY_STATUS[code]}
    >
      {t(`materialStatus.${audience}.${code}`)}
      {chevron ? <ChevronUp className='size-4' strokeWidth={2.4} /> : null}
    </Badge>
  );
}
